/**
 * query key 팩토리.
 *
 * 규칙
 * - entity 마다 팩토리 하나: `entities/<domain>/api/<domain>.query.ts` 에서
 *   `export const orderKeys = createQueryKeys('order')`
 * - 모양은 `[entity, 'list' | 'detail' | <이름>, 인자]`. 손으로 배열을 쓰지 않는다.
 * - 변경(mutation)이 성공하면 key 앞부분으로 무효화한다:
 *   `queryClient.invalidateQueries({ queryKey: orderKeys.all })`
 *   목록만이면 `orderKeys.lists()`, 한 건이면 `orderKeys.detail(id)`
 * - 인자는 직렬화할 수 있는 값만(클래스 인스턴스 · Date 금지).
 */
export type QueryKeyParams = Readonly<Record<string, unknown>>;

export function createQueryKeys<const Entity extends string>(entity: Entity) {
  const all = [entity] as const;
  return {
    all,
    lists: () => [...all, 'list'] as const,
    list: <P extends QueryKeyParams>(params: P) => [...all, 'list', params] as const,
    details: () => [...all, 'detail'] as const,
    detail: (id: string | number) => [...all, 'detail', String(id)] as const,
    /** 목록 · 상세가 아닌 조회(집계 등) */
    scope: <const Name extends string, P extends QueryKeyParams = QueryKeyParams>(
      name: Name,
      params?: P,
    ) => (params === undefined ? ([...all, name] as const) : ([...all, name, params] as const)),
  };
}
